import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <path d="M18.08,8.79l-1.67,1.67H5.74V23.84H19.12v-9l1.67-1.68V25.52H4.06V8.79Zm5-2.63H15.84a.84.84,0,0,1,0-1.68h10.1v10.1a.84.84,0,0,1-1.68,0V7.35L12.44,19.44l-1.19-1.17Z" />
  </React.Fragment>,
  'LinkExternal'
)
